import Inspection from './Inspection';
export default Inspection;
